import { render, staticRenderFns } from "./SupportingDocuments.vue?vue&type=template&id=44164fce&scoped=true"
import script from "./SupportingDocuments.vue?vue&type=script&lang=js"
export * from "./SupportingDocuments.vue?vue&type=script&lang=js"
import style0 from "./SupportingDocuments.vue?vue&type=style&index=0&id=44164fce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44164fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44164fce')) {
      api.createRecord('44164fce', component.options)
    } else {
      api.reload('44164fce', component.options)
    }
    module.hot.accept("./SupportingDocuments.vue?vue&type=template&id=44164fce&scoped=true", function () {
      api.rerender('44164fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/SupportingDocuments.vue"
export default component.exports